'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DrawerBody", {
    enumerable: true,
    get: function() {
        return DrawerBody;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const _useDrawerBody = require("./useDrawerBody");
const _renderDrawerBody = require("./renderDrawerBody");
const _useDrawerBodyStylesstyles = require("./useDrawerBodyStyles.styles");
const DrawerBody = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useDrawerBody.useDrawerBody_unstable)(props, ref);
    (0, _useDrawerBodyStylesstyles.useDrawerBodyStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useDrawerBodyStyles_unstable')(state);
    return (0, _renderDrawerBody.renderDrawerBody_unstable)(state);
});
DrawerBody.displayName = 'DrawerBody';
